import { useCallback } from 'react';
import useModal from 'hooks/useModal';
import * as track from 'lib/gaTracking/crossPageEvents';
import { downloadInvoiceErrorModalProps } from './DownloadInvoiceErrorModal';

export const useDownloadInvoiceErrorModal = () => {
  const { showModal } = useModal();

  return useCallback(() => {
    track.invoiceDownloadFailedModalOpened();
    showModal({
      ...downloadInvoiceErrorModalProps,
      onClose: ({ actionButtonClicked }) => {
        track.invoiceDownloadFailedModalClosed(actionButtonClicked);
      },
    });
  }, [showModal]);
};
